import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Smartphone } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="text-white">
      {/* Outer container - controls the max width on desktop */}
      <div className="max-w-[1664px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Blue background - contained within max-w-7xl on desktop */}
        <div className="bg-[#1e3a5f]">
          {/* Main Footer Content */}
          <div className="px-4 sm:px-6 lg:px-8 py-12">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:justify-items-stretch">
              
              {/* Kontakt - Links */}
              <div className="lg:justify-self-start">
                <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
                <ul className="space-y-3 text-white/80 text-sm">
                  <li className="flex items-start gap-2">
                    <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                    <span>Poststraße 6<br />46236 Bottrop</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <Phone className="w-4 h-4 flex-shrink-0" />
                    <a href="tel:+4920419878666" className="hover:text-white transition-colors">
                      02041 9878 666
                    </a>
                  </li>
                  <li className="flex items-center gap-2">
                    <Smartphone className="w-4 h-4 flex-shrink-0" />
                    <a href="tel:+4917680151197" className="hover:text-white transition-colors">
                      0176 8015 1197
                    </a>
                  </li>
                  <li className="flex items-center gap-2">
                    <Mail className="w-4 h-4 flex-shrink-0" />
                    <a href="mailto:info@erstehilfebottrop.de" className="hover:text-white transition-colors">
                      info@erstehilfebottrop.de
                    </a>
                  </li>
                  <li className="flex items-start gap-2">
                    <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" />
                    <span>Telefonisch erreichbar:<br />Montag – Sonntag, 09:00 – 17:00 Uhr</span>
                  </li>
                </ul>
              </div>

              {/* Kurse & Angebote - Mitte links */}
              <div className="lg:justify-self-center">
                <h3 className="text-lg font-semibold mb-4">Kurse & Angebote</h3>
                <ul className="space-y-2 text-white/80 text-sm">
                  <li>
                    <a 
                      href="/#paket-auswahl" 
                      onClick={(e) => {
                        // If already on homepage, scroll to section
                        if (window.location.pathname === '/') {
                          e.preventDefault();
                          const element = document.getElementById('paket-auswahl');
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                          } else {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }
                        }
                      }}
                      className="hover:text-white transition-colors cursor-pointer"
                    >
                      Erste-Hilfe-Kurs
                    </a>
                  </li>
                  <li>
                    <Link to="/brandschutzhelfer" className="hover:text-white transition-colors">
                      Brandschutzhelfer
                    </Link>
                  </li>
                  <li>
                    <Link to="/sanitaetsdienste" className="hover:text-white transition-colors">
                      Sanitätsdienste
                    </Link>
                  </li>
                  <li>
                    <Link to="/termine" className="hover:text-white transition-colors">
                      Termine & Anmeldung
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Service - Mitte rechts */}
              <div className="lg:justify-self-center">
                <h3 className="text-lg font-semibold mb-4">Service</h3>
                <ul className="space-y-2 text-white/80 text-sm">
                  <li>
                    <Link to="/kontakt" className="hover:text-white transition-colors">
                      Kontakt
                    </Link>
                  </li>
                  <li>
                    <a 
                      href="https://wa.me/4917680151197?text=Hallo%20Erste%20Hilfe%20Bottrop%2C%20ich%20habe%20eine%20Frage." 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="hover:text-white transition-colors"
                    >
                      WhatsApp Chat
                    </a>
                  </li>
                </ul>
              </div>

              {/* Rechtliches - Rechts */}
              <div className="lg:justify-self-end lg:text-right">
                <h3 className="text-lg font-semibold mb-4">Rechtliches</h3>
                <ul className="space-y-2 text-white/80 text-sm">
                  <li>
                    <Link to="/impressum" className="hover:text-white transition-colors">
                      Impressum
                    </Link>
                  </li>
                  <li>
                    <Link to="/datenschutz" className="hover:text-white transition-colors">
                      Datenschutz
                    </Link>
                  </li>
                  <li>
                    <Link to="/cookie-richtlinie" className="hover:text-white transition-colors">
                      Cookie-Richtlinie (EU)
                    </Link>
                  </li>
                  <li>
                    <Link to="/datenschutz-social-media" className="hover:text-white transition-colors">
                      Datenschutz Social Media
                    </Link>
                  </li>
                </ul>
              </div>

            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/20">
            <div className="px-4 sm:px-6 lg:px-8 py-6">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <p className="text-white/70 text-sm text-center sm:text-left">
                  © {new Date().getFullYear()} Erste Hilfe Bottrop – Alle Rechte vorbehalten
                </p>
                <p className="text-white font-medium text-sm">
                  Erste Hilfe Bottrop – Aktiv helfen
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
